import React from "react";
import {
  Modal,
  Box,
  Typography,
  Paper,
  IconButton,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import { InputField } from "../../../pro/applicationForm/input";
import { CustomSelectField } from "../../../pro/applicationForm/customSelect";
import FieldCheckbox from "../../../pro/createEditProfile/formFragments/FieldCheckbox";

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  //brand_ids: Yup.array().min(1, "Select at least one brand"),
});

// Channels are no longer configured per content type here — every content
// type carries all generic content channels (the junction is managed from
// the Content Channels admin if restrictions are ever needed).
const ContentTypeModal = ({
  open,
  onClose,
  onSave,
  brands = [],
  initialData = {},
}) => {
  const brandOptions = brands.map((brand) => ({
    label: brand.name,
    value: brand.id,
  }));

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        component={Paper}
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "calc(100% - 24px)", sm: 520 },
          maxWidth: 520,
          maxHeight: { xs: "calc(100vh - 24px)", sm: "80vh" },
          bgcolor: "white",
          borderRadius: "12px",
          boxShadow: 24,
          padding: { xs: "16px", sm: "24px" },
          overflow: "auto",
        }}
      >
        <Formik
          validationSchema={validationSchema}
          initialValues={{
            name: initialData.name || "",
            brand_ids: initialData.brands?.map((b) => b.id) || [],
            isActive: initialData.deactivated === false,
            expert_connect: initialData?.expert_connect || false,
          }}
          enableReinitialize
          onSubmit={({ isActive, ...rest }) => {
            const payload = {
              ...rest,
              deactivated: !isActive,
            };
            onSave(payload);
          }}
        >
          {({ isValid, dirty }) => (
            <Form className="flex flex-col gap-4">
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography sx={{ fontSize: "24px", fontWeight: 900 }}>
                  {initialData?.id ? "Edit" : "Add"} Content Type
                </Typography>
                <IconButton onClick={onClose}>
                  <CloseIcon />
                </IconButton>
              </Box>

              <InputField
                name="name"
                placeholder="Enter name"
                label="Name"
                required
                type="text"
              />

              <CustomSelectField
                name="brand_ids"
                label="Brands"
                required
                options={brandOptions}
                renderValue={(selected) => {
                  if (!selected || selected.length === 0) {
                    return "Select Brands";
                  }
                  return `${selected.length} Brand${
                    selected.length === 1 ? "" : "s"
                  } Selected`;
                }}
              />

              <FieldCheckbox name="expert_connect" text="Portal Enabled" />

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 2,
                  mt: 1,
                }}
              >
                <Button onClick={onClose} type="button">
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={!(isValid && dirty)}
                >
                  {initialData?.id ? "Save" : "Add"}
                </Button>
              </Box>
            </Form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
};

export default ContentTypeModal;
